import React from 'react';
import { Button } from 'equasion-lib';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import './ActionTopBar.scss';

const ActionTopBar = ({
  action,
  serialNumber,
  gtin,
  purchaseOrderNumber,
  backPath,
  // Replaces the navigation entirely — a screen holding unsaved work asks before it leaves.
  onBack,
  actionColor,
  children
}) => {
  const navigate = useNavigate();

  return (
    <div className={`action-top-bar${children ? ' has-detail' : ''}`}>
      <Button
        type="secondary"
        iconBefore={<FiChevronLeft />}
        onClick={() => {
          if (onBack) {
            onBack();
            return;
          }
          if (backPath) {
            const [pathname, search] = backPath.split('?');
            navigate({ pathname, search: search ? `?${search}` : undefined });
            return;
          }
          navigate({
            pathname: '/scanned-options',
            search: serialNumber
              ? `?serialNumber=${serialNumber}${gtin ? `&gtin=${gtin}` : ''}`
              : `?purchaseOrderNumber=${purchaseOrderNumber}`
          });
        }}
      >
        Back
      </Button>
      <div className={`status${children ? ' has-detail' : ''}`}>
        <span className="status-title">
          {!!actionColor && (
            <div className="action-color" style={{ backgroundColor: actionColor }}></div>
          )}
          {action}
        </span>
        {children}
      </div>
    </div>
  );
};

export default ActionTopBar;
